import { openDB } from 'idb';
import { EMI } from '../models/emi';

const dbPromise = openDB('emi-db', 1, {
  upgrade(db) {
    db.createObjectStore('emi', { keyPath: 'id', autoIncrement: true });
  },
});
 
// export const saveEMI = async ({
//   amount,
//   interest,
//   period,
//   title,
//   currencySymbol,
// }: EMI): Promise<void> => {
//   const db = await dbPromise;
//   await db.add('emi', {  
//     amount,
//     interest,
//     period,
//     title,
//     currencySymbol,
//   });
// };

export const saveEMI = async (data: EMI): Promise<void> => {
  const db = await dbPromise;
  await db.add('emi', data);
};

export const fetchEMIs = async (): Promise<EMI[]> => {
  const db = await dbPromise;
  const allEMIs: EMI[] = await db.getAll('emi');
  return allEMIs;
};

export const updateEMI = async (
  id: number,
  updatedData: Omit<EMI, 'id'>
): Promise<void> => {
  const db = await dbPromise;
  await db.put('emi', { id, ...updatedData });
};

export const deleteEMI = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('emi', id);
};
